import { Map } from 'immutable'
import { createSelector } from 'reselect'

const getWellnessCheckInState = (state: Map<string, any>) => state?.get('wellnessCheckIn')

export const getWellnessCheckInEntryPoint = createSelector(getWellnessCheckInState, (wellnessCheckInState) =>
  wellnessCheckInState?.get('wellnessCheckInEntryPoint'),
)

export const getWellnessCheckInFormValues = createSelector(getWellnessCheckInState, (wellnessCheckInState) =>
  wellnessCheckInState?.get('wellnessCheckInFormValues'),
)

export const getShouldSaveWellnessCheckInPostLogin = createSelector(getWellnessCheckInState, (wellnessCheckInState) =>
  wellnessCheckInState?.get('shouldSaveWellnessCheckInPostLogin'),
)

export const getWellnessCheckInResultsList = createSelector(getWellnessCheckInState, (wellnessCheckInState) =>
  wellnessCheckInState?.get('wellnessCheckInResultsList'),
)

export const getWellnessCheckInParsedResults = createSelector(getWellnessCheckInState, (wellnessCheckInState) =>
  wellnessCheckInState?.get('wellnessCheckInParsedResults'),
)

export const getWellnessCheckInStateResults = createSelector(
  getWellnessCheckInParsedResults,
  (wellnessCheckInParsedResults) => wellnessCheckInParsedResults?.results,
)

export const getIsWellnessCheckInResultsWithinThreeMonths = createSelector(
  getWellnessCheckInParsedResults,
  (wellnessCheckInParsedResults) => wellnessCheckInParsedResults?.withinPastThreeMonths,
)

export const getWellnessCheckInResultsDate = createSelector(
  getWellnessCheckInParsedResults,
  (wellnessCheckInParsedResults) => wellnessCheckInParsedResults?.date,
)
